import React, { useMemo } from 'react';
import {
  SectionContainer,
  SectionTextContainer,
} from '../../../aboutUs/styles';
import { Box, VerticalBox } from '../../../../components';
import { Features } from '../../../../types/globalTypes';
import { FeatureSwiper } from './FeatureSwiper';
import { FeaturesContainer } from './FeaturesContainer';
import { MotionYOffsetBlock } from '../../../../components/Motion';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  features: Features[];
}
const FEATURES_PER_SLIDE = 4;
export const ProjectFeatures: React.FC<DivProps> = ({ features }) => {
  const data = useMemo(() => {
    const result = [];
    for (let i = 0; i < features.length; i += FEATURES_PER_SLIDE) {
      result.push(features.slice(i, i + FEATURES_PER_SLIDE));
    }
    return result;
  }, [features]);

  return (
    <SectionContainer>
      <Box>
        <VerticalBox>
          <SectionTextContainer>
            <MotionYOffsetBlock>
              <FeatureSwiper
                data={data}
                renderItem={item => <FeaturesContainer data={item} />}
              />
            </MotionYOffsetBlock>
          </SectionTextContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};
